<template>
  <div id="app">

    <div class="row">
      <div class="columns small-12">
        <div class="enable-bootstrap">
          <div class="compare-tariffs">
            <ul class="nav nav-tabs" role="tablist">
              <li><a class="power" href="#" aria-controls="power" role="tab" data-toggle="tab" data-tab="1" v-on:click="loadtab(1)" v-bind:class="[acttab == 1 ? 'active' : '']">Strom</a></li>
              <li><a class="gas" href="#" aria-controls="gas" role="tab" data-toggle="tab" data-tab="2" v-on:click="loadtab(2)" v-bind:class="[acttab == 2 ? 'active' : '']">Erdgas</a></li>
            </ul>

            <div id="tabcontent" class="tab-content">

              <Strom :defaultSettings="defaultSettings" :reassignInput="reassignInput" :maintenance="maintenance" id="cStrom" v-if="acttab == 1" />
              <Erdgas :defaultSettings="defaultSettings" :reassignInput="reassignInput" :maintenance="maintenance" v-else />

            </div>
          </div>

          <div v-show="loading" id="loading-overlay">
            <img class="loading-overlay-image" src="./assets/Images/ajax-loader.gif" alt="Loading"/>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>






<script>
import $ from 'jquery';

import Strom from './components/Strom.vue';
import Erdgas from './components/Erdgas.vue';

import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin, ModalPlugin, CardPlugin, VBScrollspyPlugin, DropdownPlugin, TablePlugin } from 'bootstrap-vue'
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(CardPlugin)
Vue.use(VBScrollspyPlugin)
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)

let defaultSettings = {};
try {
  defaultSettings = JSON.parse(document.getElementById('defaultSettings').innerHTML);
}
catch(e) {
  console.log('defaultSettings not found!');
}
let reassignInput = {};
try {
  reassignInput = JSON.parse(document.getElementById('reassignInput').innerHTML);
}
catch(e) {
  console.log('reassignInput not found!');
}
let maintenance = {};
try {
  maintenance = JSON.parse(document.getElementById('maintenance').innerHTML);
}
catch(e) {
  console.log('maintenance not found!');
}

export default {
  name: 'App',
  components: {
    Strom,
    Erdgas
  },
  data() {
    return {
      acttab: 1,
      loading: false,
      settings: defaultSettings,
      reassignInput: reassignInput,
      maintenance: maintenance
    }
  },
  computed: {
    defaultSettings: function () {
      return this.settings;
    }
  },
  methods: {
    loader (status) {
      this.loading = status;
    },
    loadtab: function (e) {
      this.acttab = e;
    },
    noCacheTimestamp: function() {
      return Date.now() + Math.floor((Math.random() * 99999999) + 1);
    }

  },
  mounted: function() {
    $('body').addClass('select2asinput');
    let that = this;

    window.calculatorLoading = function(status) {
      that.loader(status);
    }
  }
};

 /* Force Select2 to always dropdown */
    var Defaults = $.fn.select2.amd.require('select2/defaults');

    $.extend(Defaults.defaults, {
      dropdownPosition: 'auto'
    });

    var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

    // var _positionDropdown = AttachBody.prototype._positionDropdown;

    AttachBody.prototype._positionDropdown = function() {

      var $window = $(window);

      var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
      var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

      var newDirection = null;

      var offset = this.$container.offset();

      offset.bottom = offset.top + this.$container.outerHeight(false);

      var container = {
          height: this.$container.outerHeight(false)
      };

      container.top = offset.top;
      container.bottom = offset.top + container.height;

      var dropdown = {
        height: this.$dropdown.outerHeight(false)
      };

      var viewport = {
        top: $window.scrollTop(),
        bottom: $window.scrollTop() + $window.height()
      };

      var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
      var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

      var css = {
        left: offset.left,
        top: container.bottom
      };

      // Determine what the parent element is to use for calciulating the offset
      var $offsetParent = this.$dropdownParent;

      // For statically positoned elements, we need to get the element
      // that is determining the offset
      if ($offsetParent.css('position') === 'static') {
        $offsetParent = $offsetParent.offsetParent();
      }

      var parentOffset = $offsetParent.offset();

      css.top -= parentOffset.top
      css.left -= parentOffset.left;

      var dropdownPositionOption = this.options.get('dropdownPosition');

      if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
        newDirection = dropdownPositionOption;
      } else {

        if (!isCurrentlyAbove && !isCurrentlyBelow) {
          newDirection = 'below';
        }

        if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
          newDirection = 'above';
        } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
          newDirection = 'below';
        }

      }

      if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
          css.top = container.top - parentOffset.top - dropdown.height;
      }

      if (newDirection != null) {
        this.$dropdown
          .removeClass('select2-dropdown--below select2-dropdown--above')
          .addClass('select2-dropdown--' + newDirection);
        this.$container
          .removeClass('select2-container--below select2-container--above')
          .addClass('select2-container--' + newDirection);
      }

      this.$dropdownContainer.css(css);

    };
</script>


<style>
/* @import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css'; */
@import './assets/DEW21/Styles/uobootstrap.css';
@import './assets/DEW21/Styles/uo.css';
@import './assets/DEW21/Styles/build.css';
@import "./assets/DEW21/Styles/all.css";
@import "./assets/DEW21/Styles/uo2020.css";
</style>